import { Injectable, signal } from '@angular/core';

export interface ITema {
  id: string;
  baslik: string;
  aciklama: string;
  onizlemeRenkler: [string, string, string];
}

export interface ITemaZamanlama {
  acik: boolean;
  geceSaat: number;
  gunduzSaat: number;
}

const ZAMANLAMA_KEY = 'fikoyt-tema-zamanlama';

@Injectable({ providedIn: 'root' })
export class TemaService {
  private STORAGE_KEY = 'fikoyt-tema';
  private BOYUT_KEY = 'fikoyt-yazi-boyutu';

  aktifTema = signal<string>('varsayilan');
  karanlikMod = signal<boolean>(false);
  yaziBoyutu = signal<number>(14);
  temaZamanlama = signal<ITemaZamanlama>({ acik: false, geceSaat: 20, gunduzSaat: 7 });

  private zamanlamaInterval: any = null;

  temalar: ITema[] = [
    { id: 'varsayilan', baslik: 'Varsayılan', aciklama: 'Klasik FikoYT', onizlemeRenkler: ['#1890ff', '#f5f5f5', '#333'] },
    { id: 'okyanus', baslik: 'Okyanus', aciklama: 'Derin mavi tonları', onizlemeRenkler: ['#0077b6', '#caf0f8', '#023e8a'] },
    { id: 'orman', baslik: 'Orman', aciklama: 'Doğal yeşil tonları', onizlemeRenkler: ['#2d6a4f', '#d8f3dc', '#1b4332'] },
    { id: 'gunbatimi', baslik: 'Gün Batımı', aciklama: 'Sıcak turuncu tonları', onizlemeRenkler: ['#e85d04', '#fff3e0', '#6a040f'] },
    { id: 'mor-ruya', baslik: 'Mor Rüya', aciklama: 'Mistik mor tonları', onizlemeRenkler: ['#7b2cbf', '#f3e5f5', '#3c096c'] },
    { id: 'kuzey-isiklari', baslik: 'Kuzey Işıkları', aciklama: 'Aurora renkleri', onizlemeRenkler: ['#00b4d8', '#e0f7fa', '#0077b6'] },
  ];

  constructor() {
    this.yukle();
    this.zamanliTemaBaslat();
  }

  private yukle() {
    const kayitli = localStorage.getItem(this.STORAGE_KEY);
    if (kayitli) {
      try {
        const { tema, karanlik } = JSON.parse(kayitli);
        this.aktifTema.set(tema || 'varsayilan');
        this.karanlikMod.set(!!karanlik);
      } catch { /* bozuk veri */ }
    } else {
      const eskiKey = localStorage.getItem('fikoyt-tema-karanlik');
      if (eskiKey === '1') this.karanlikMod.set(true);
    }
    const boyut = localStorage.getItem(this.BOYUT_KEY);
    if (boyut) this.yaziBoyutu.set(parseInt(boyut) || 14);

    try {
      const zamKayitli = localStorage.getItem(ZAMANLAMA_KEY);
      if (zamKayitli) this.temaZamanlama.set({ ...this.temaZamanlama(), ...JSON.parse(zamKayitli) });
    } catch {}

    this.uygula();
  }

  temaDegistir(temaId: string) {
    this.aktifTema.set(temaId);
    this.kaydetVeUygula();
  }

  karanlikToggle() {
    this.karanlikMod.update(k => !k);
    this.kaydetVeUygula();
  }

  karanlikAyarla(deger: boolean) {
    this.karanlikMod.set(deger);
    this.kaydetVeUygula();
  }

  yaziBoyutuDegistir(boyut: number) {
    this.yaziBoyutu.set(boyut);
    localStorage.setItem(this.BOYUT_KEY, boyut.toString());
    document.documentElement.style.fontSize = boyut + 'px';
  }

  zamanlamaKaydet(zamanlama: Partial<ITemaZamanlama>) {
    this.temaZamanlama.update(z => ({ ...z, ...zamanlama }));
    localStorage.setItem(ZAMANLAMA_KEY, JSON.stringify(this.temaZamanlama()));
    this.zamanliTemaKontrol();
  }

  private zamanliTemaBaslat() {
    this.zamanliTemaKontrol();
    this.zamanlamaInterval = setInterval(() => this.zamanliTemaKontrol(), 60_000);
  }

  private zamanliTemaKontrol() {
    const z = this.temaZamanlama();
    if (!z.acik) return;
    const saat = new Date().getHours();
    const geceVaktiMi = saat >= z.geceSaat || saat < z.gunduzSaat;
    if (geceVaktiMi && !this.karanlikMod()) {
      this.karanlikMod.set(true);
      this.kaydetVeUygula();
    } else if (!geceVaktiMi && this.karanlikMod()) {
      this.karanlikMod.set(false);
      this.kaydetVeUygula();
    }
  }

  private kaydetVeUygula() {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      tema: this.aktifTema(),
      karanlik: this.karanlikMod()
    }));
    localStorage.setItem('fikoyt-tema-karanlik', this.karanlikMod() ? '1' : '0');
    this.uygula();
  }

  private uygula() {
    const body = document.body;
    const html = document.documentElement;
    this.temalar.forEach(t => {
      body.classList.remove('tema-' + t.id);
      html.classList.remove('tema-' + t.id);
    });
    body.classList.remove('tema-karanlik');
    html.classList.remove('tema-karanlik');

    const tema = this.aktifTema();
    if (tema !== 'varsayilan') {
      body.classList.add('tema-' + tema);
      html.classList.add('tema-' + tema);
    }
    if (this.karanlikMod()) {
      body.classList.add('tema-karanlik');
      html.classList.add('tema-karanlik');
    }

    document.documentElement.style.fontSize = this.yaziBoyutu() + 'px';
  }
}
